import { Image } from '@/shared/ui/image';
import { useWishlist } from '../model/hooks';
import { Box } from '@/shared/ui/box';
import { useUser } from '@/shared/providers/user-provider/use-user';
import { Condition } from '@/shared/ui/condition';
import { withBreakpointsSlice } from '@/shared/providers/utils/with-breakpoints-slice';
import { WishButtonStyled, WishlistButtonMobile } from './styles';

const WishlistToggle = ({
  gameId,
  Container,
  iconSize,
  checkedPath,
  uncheckedPath,
  mobileLandscape,
}) => {
  const { trigger } = useWishlist();
  const { user, mutateWishlist } = useUser();
  const isInWishlist = user.isAuth && user.wishlist.includes(gameId);

  const handleToggle = async () => {
    try {
      await trigger({
        gameId,
        val: !isInWishlist,
      });
      mutateWishlist();
    } catch (error) {}
  };

  // if (mobileLandscape) {
  //   return (
  //     <Condition match={user.isAuth}>
  //       <Box>
  //         <WishlistButtonMobile
  //           $isSelected={isInWishlist}
  //           variant="gray"
  //           style={{
  //             padding: '0',
  //             borderRadius: '100px',
  //             height: '40px',
  //             width: '40px',
  //           }}
  //           icon={
  //             <Image
  //               width={20}
  //               height={20}
  //               src={
  //                 isInWishlist
  //                   ? '/images/icons/heart-filled-ver2.svg'
  //                   : '/images/icons/heart-unfilled-ver2.svg'
  //               }
  //             />
  //           }
  //           onClick={handleToggle}
  //         ></WishlistButtonMobile>
  //       </Box>
  //     </Condition>
  //   );
  // }

  return (
    <Condition match={user.isAuth}>
      <Container onClick={handleToggle}>
        <Image
          style={{ display: 'flex' }}
          width={iconSize}
          height={iconSize}
          src={isInWishlist ? checkedPath : uncheckedPath}
        />
      </Container>
    </Condition>
  );
};

const WishlistToggleWithBreakpointsSlice = withBreakpointsSlice(
  WishlistToggle,
  ({ mobileLandscape }) => ({
    mobileLandscape,
  })
);

export { WishlistToggleWithBreakpointsSlice as WishlistToggle };
